import { ActionReducerMap } from "@ngrx/store";
import * as Reducer from "@cradua/epims-references";
import * as StakeholderReferenceReducer from "@cradua/stakeholderreference";
import * as StakeholderReducer from "@cradua/stakeholder";
import * as AnchorEPIMSReducer from "@cradua/anchorepimsgates";
import * as PaymentReducer from "@cradua/scholarship-management";
import * as ProjectReducer from "@cradua/project-management";
import * as CorrespondenceReducer from "@cradua/correspondence-management";
import * as pipelinedetailsReducer from '@cradua/pipeline';

import * as Auth from 'libs/auth/src/lib/reducers/auth.reducer';
import * as User from 'libs/auth/src/lib/reducers/user.reducer';
import * as LoginPage from 'libs/auth/src/lib/reducers/login-page.reducer';

export interface AppState {
  stakeholderreference:
    StakeholderReferenceReducer.StakeholderReferenceStoreReducer.StakeholderReferenceState;
  stakeholderreferencegroup:
    StakeholderReferenceReducer.StakeholderReferenceGroupStoreReducer.StakeholderReferenceGroupState;
  stakeholder: StakeholderReducer.StakeholderStoreReducer.StakeholderState;
  country: Reducer.CountryStoreReducer.CountryState;
  epimsState: Reducer.StateStoreReducer.StateState;
  lga: Reducer.LgaStoreReducer.LgaState;
  courseofstudy: Reducer.CourseOfStudyStoreReducer.CourseOfStudyState;
  scholarshipcategory:
    Reducer.ScholarshipCategoryStoreReducer.ScholarshipCategoryState;
  scholarshiptype: Reducer.ScholarshipTypeStoreReducer.ScholarshipTypeState;
  scholarshipsession:
    Reducer.ScholarshipSessionStoreReducer.ScholarshipSessionState;
  scholarshipawardduration:
    Reducer.ScholarshipAwardDurationStoreReducer.ScholarshipAwardDurationState;
  community: Reducer.CommunityStoreReducer.CommunityState;
  gender: Reducer.GenderStoreReducer.GenderState;
  bank: Reducer.EpimsBankStoreReducer.EpimsBankState;
  payment:
    PaymentReducer.ScholarshipPaymentStoreReducer.ScholarshipPaymentState;
  bankdetail: Reducer.EpimsBankDetailStoreReducer.EpimsBankDetailState;
  currency: Reducer.CurrencyStoreReducer.CurrencyState;
  projectcategory: Reducer.ProjectCategoryStoreReducer.ProjectCategoryState;
  projecttype: Reducer.ProjectTypeStoreReducer.ProjectTypeState;
  cluster: Reducer.ClusterStoreReducer.ClusterState;
  clustercommunity: Reducer.ClusterCommunityStoreReducer.ClusterCommunityState;
  oilblock: Reducer.OilBlockStoreReducer.OilBlockState;
  oilfield: Reducer.OilFieldStoreReducer.OilFieldState;
  documentcategory: Reducer.DocumentCategoryStoreReducer.DocumentCategoryState;
  documentsubcategory:
    Reducer.DocumentSubCategoryStoreReducer.DocumentSubCategoryState;
  gmou: ProjectReducer.GmouStoreReducer.GmouState;
  projectActivity:
    ProjectReducer.ProjectActivityStoreReducer.ProjectActivityState;
  projectCluster: ProjectReducer.ProjectClusterStoreReducer.ProjectClusterState;
  projectDocument:
    ProjectReducer.ProjectDocumentStoreReducer.ProjectDocumentState;
  projectPayment: ProjectReducer.ProjectPaymentStoreReducer.ProjectPaymentState;
  projectStakeholder:
    ProjectReducer.ProjectStakeholderStoreReducer.ProjectStakeholderState;
  progressMeeting:
    ProjectReducer.ProgressMeetingStoreReducer.ProgressMeetingState;
  progressMaster: ProjectReducer.ProgressMasterStoreReducer.ProgressMasterState;
  progressHistory:
    ProjectReducer.ProgressHistoryStoreReducer.ProgressHistoryState;
  anchorepims: AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.EPIMSGateState;
  anchorepimsengagement:
    AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.EPIMSGateState;
  anchorepimslanguage:
    AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.EPIMSGateState;
  anchorepimsdocument:
    AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.EPIMSGateState;
    pipelinedetails: pipelinedetailsReducer.PipelinedetailsStoreReducer.PipelinedetailsState;
    Auth: Auth.State;
	LoginPage: LoginPage.State;
	user: User.UserState;

}

export const reducers: ActionReducerMap<AppState> = {
  country: Reducer.CountryStoreReducer.reducer,
  stakeholderreference:
    StakeholderReferenceReducer.StakeholderReferenceStoreReducer.reducer,
  stakeholderreferencegroup:
    StakeholderReferenceReducer.StakeholderReferenceGroupStoreReducer.reducer,
  stakeholder: StakeholderReducer.StakeholderStoreReducer.reducer,
  epimsState: Reducer.StateStoreReducer.reducer,
  lga: Reducer.LgaStoreReducer.reducer,
  courseofstudy: Reducer.CourseOfStudyStoreReducer.reducer,
  scholarshipcategory: Reducer.ScholarshipCategoryStoreReducer.reducer,
  scholarshiptype: Reducer.ScholarshipTypeStoreReducer.reducer,
  scholarshipsession: Reducer.ScholarshipSessionStoreReducer.reducer,
  scholarshipawardduration:
    Reducer.ScholarshipAwardDurationStoreReducer.reducer,
  community: Reducer.CommunityStoreReducer.reducer,
  gender: Reducer.GenderStoreReducer.reducer,
  bank: Reducer.EpimsBankStoreReducer.reducer,
  payment: PaymentReducer.ScholarshipPaymentStoreReducer.reducer,
  bankdetail: Reducer.EpimsBankDetailStoreReducer.reducer,
  currency: Reducer.CurrencyStoreReducer.reducer,
  projectcategory: Reducer.ProjectCategoryStoreReducer.reducer,
  projecttype: Reducer.ProjectTypeStoreReducer.reducer,
  cluster: Reducer.ClusterStoreReducer.reducer,
  clustercommunity: Reducer.ClusterCommunityStoreReducer.reducer,
  oilblock: Reducer.OilBlockStoreReducer.reducer,
  oilfield: Reducer.OilFieldStoreReducer.reducer,
  documentcategory: Reducer.DocumentCategoryStoreReducer.reducer,
  documentsubcategory: Reducer.DocumentSubCategoryStoreReducer.reducer,
  gmou: ProjectReducer.GmouStoreReducer.reducer,
  projectActivity: ProjectReducer.ProjectActivityStoreReducer.reducer,
  projectCluster: ProjectReducer.ProjectClusterStoreReducer.reducer,
  projectDocument: ProjectReducer.ProjectDocumentStoreReducer.reducer,
  projectPayment: ProjectReducer.ProjectPaymentStoreReducer.reducer,
  projectStakeholder: ProjectReducer.ProjectStakeholderStoreReducer.reducer,
  progressMeeting: ProjectReducer.ProgressMeetingStoreReducer.reducer,
  progressMaster: ProjectReducer.ProgressMasterStoreReducer.reducer,
  progressHistory: ProjectReducer.ProgressHistoryStoreReducer.reducer,
  anchorepimsengagement:
    AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.engagementreducer,
  anchorepims: AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.reducer,
  anchorepimslanguage:
    AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.languagereducer,
  anchorepimsdocument:
    AnchorEPIMSReducer.AnchorEPIMSSStoreReducer.documentreducer,
    pipelinedetails: pipelinedetailsReducer.PipelinedetailsStoreReducer.reducer,

    Auth: Auth.reducer,
    LoginPage: LoginPage.reducer,
    user: User.reducer,
};
